import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-display',
  templateUrl: './empty-display.component.html',
  styleUrls: ['./empty-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmptyDisplayComponent {
  @Input() isCollection: boolean = false;
  @Input() hasScheduledMenus: boolean = false;
}
